import { render } from "./cookie-notice-component.vue?vue&type=template&id=4593c5e8&ts=true"
import script from "./cookie-notice-component.vue?vue&type=script&lang=ts"
export * from "./cookie-notice-component.vue?vue&type=script&lang=ts"

import "./cookie-notice-component.vue?vue&type=style&index=0&id=4593c5e8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__